var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-block"},[_c('h3',{staticClass:"text-block__heading"},[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"text-block__box"},[_vm._t("default")],2),(_vm.buttonLink && _vm.buttonText)?_c('AppButton',{staticClass:"text-block__button",attrs:{"link":_vm.buttonLink,"text":_vm.buttonText}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }